import { createSelector } from 'reselect';
import { READY } from 'settings/constants/apiState';

const localState = ({ offerBuyingAgents }) => offerBuyingAgents;

export const getAllOfferBuyingAgentsSelector = createSelector(localState, ({ state, data }) => {
  return { isReady: state === READY, buyingAgents: data };
});
